var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("app-header"),
        _vm._v(" "),
        _c("router-view"),
        _vm._v(" "),
        _c("app-footer"),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "z-index": "20000" }, attrs: { id: "snackbar" } },
          [_vm._v("Some text some message..")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }